import { MessageWindow } from '@repo/studio-components/message-window'
import { AnimatePresence, m } from 'framer-motion'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { useTrialCtaCopy } from '@repo/studio-hooks-payments/use-trial-cta'
import { TryForFreeButton } from './try-for-free-button'

export function FreeAccessMessage({ className, show }: { className?: string; show: boolean }) {
  const t = useStudioTranslate()
  const { title, content } = useTrialCtaCopy({
    control: {
      title: t('studio.components.subscription_message.title'),
      content: t('studio.components.subscription_message.content'),
    },
    pricingPage: {
      title: t('studio.components.subscription_message.pricing_title'),
      content: t('studio.components.subscription_message.pricing_content'),
    },
  })

  return (
    <AnimatePresence initial={false}>
      {show ? (
        <m.div
          className={className}
          initial={{
            opacity: 0,
          }}
          animate={{ opacity: 1, transition: { duration: 0.2, delay: 0.2 } }}
          exit={{
            opacity: 0,
            transition: { duration: 0 },
          }}
        >
          <MessageWindow variant="3d" className="overflow-clip">
            <span className="typography-13 font-bold">{title}</span>
            <span className="typography-13 text-gray-300">{content}</span>
            <TryForFreeButton />
          </MessageWindow>{' '}
        </m.div>
      ) : null}
    </AnimatePresence>
  )
}
